import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import DrawerHeaderStyled from "./DrawerHeaderStyled";
import { ReactComponent as Logo } from "assets/images/icons/Logo-unity_light.svg";
import { ReactComponent as Burger } from "assets/images/icons/btn_burger_light.svg";
import { ReactComponent as Close } from "assets/images/icons/btn_close_light.svg";
import useConfig from "hooks/useConfig";
import { MenuOrientation } from "config";

export default function DrawerHeader({ open, toggleDrawer }) {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));
  const { menuOrientation } = useConfig();
  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  return (
    <DrawerHeaderStyled
      theme={theme}
      open={open}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: open ? "space-between" : "center",
        minHeight: isHorizontal ? "unset" : "60px",
        width: isHorizontal ? { xs: "100%", lg: "424px" } : "initial",
        paddingTop: isHorizontal
          ? { xs: "10px", lg: "0" }
          : open
          ? "16px"
          : "8px",
        paddingBottom: isHorizontal ? { xs: "18px", lg: "0" }  : open
          ? "8px"
          : "16px",
        paddingLeft: isHorizontal ? { xs: "24px", lg: "0" } : open ? "24px" : 0,
        paddingRight: open ? "24px" : 0,
      }}
    >
      {open ? (
        <>
          <Logo sx={{ width: "auto", height: 35, mt: 1 }} />
          <Box
            sx={{ ml: "auto", mt: 1, cursor: "pointer" }}
            onClick={() => toggleDrawer(false)}
          >
            <Close sx={{ width: 24, height: 24, cursor: "pointer" }} />
          </Box>
        </>
      ) : (
        <Box sx={{ cursor: "pointer" }} onClick={() => toggleDrawer(true)}>
          <Burger sx={{ width: 35, height: 35 }} style={{ transform: "translateY(5px)" }}/>
        </Box>
      )}
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = {
  open: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
};
